import React, { useEffect, useState } from 'react';
import { validatePassword } from 'features/Auth/utils/password.utils';
import PasswordInput from 'components/UI/PasswordInput';

import { Button } from 'react-bootstrap';
import { IoKeyOutline } from 'react-icons/io5';
import UserMenuPanel from './UserMenu/components/UserMenuPanel';
import { updateFusionPassword } from 'services/account/account.service';

export const UpdatePassword = ({ setShowChangePassword }) => {
  const [changePasswordSuccess, setChangePasswordSuccess] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!currentPassword) {
      setError('Original password is required');
      return;
    }

    if (!validatePassword(newPassword).isValid) {
      setError(validatePassword(newPassword).message);
      return;
    }
    setError(null);
    // make api call to change password
    (async () => {
      try {
        const res = await updateFusionPassword(currentPassword, newPassword);

        setError('Password changed successfully');
        // setShowChangePassword(false);
        setChangePasswordSuccess(true);

        setConfirmPassword(null);
        setCurrentPassword(null);
        setNewPassword(null);
      } catch (e) {
        setError('Error changing password: ' + e.response.data.message);
      }
    })();
  };

  useEffect(() => {
    if (newPassword === null || confirmPassword === null || currentPassword == null) {
      setError(null);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (newPassword === currentPassword) {
      setError('New password cannot be the same as the current password');
      return;
    }
    if (!validatePassword(newPassword).isValid) {
      setError(validatePassword(newPassword).message);
      return;
    }

    setError(null);
  }, [newPassword, confirmPassword]);

  const backToAccount = () => {
    setShowChangePassword(false);
    setChangePasswordSuccess(false);
    setConfirmPassword(null);
    setCurrentPassword(null);
    setNewPassword(null);
  };

  if (changePasswordSuccess)
    return (
      <UserMenuPanel icon={<IoKeyOutline />} title="Change Password">
        <p className="user-menu-status mb-0" data-tone="success" role="status">
          Password Update Successful
        </p>
        <Button variant="primary" className="align-self-start" onClick={backToAccount}>
          Return to Account
        </Button>
      </UserMenuPanel>
    );

  return (
    <UserMenuPanel
      icon={<IoKeyOutline />}
      title="Change Password"
      actions={
        <Button variant="secondary" onClick={backToAccount}>
          Back
        </Button>
      }
    >
      <div className="d-flex flex-column gap-2 w-100 max-w-md">
        <PasswordInput
          label="Current password"
          callback={setCurrentPassword}
          value={currentPassword}
        />
        <PasswordInput label="New password" callback={setNewPassword} value={newPassword} />
        <PasswordInput
          label="Confirm new password"
          callback={setConfirmPassword}
          value={confirmPassword}
        />
      </div>
      <div className="user-menu-actions">
        <p className="user-menu-status" data-tone="error" role="status">
          {error}
        </p>
        <Button variant="primary" onClick={handleSubmit}>
          Update Password
        </Button>
      </div>
    </UserMenuPanel>
  );
};
